// extracted by mini-css-extract-plugin
export default {"title":"jX_8PZDdDIwKKg2Suvic","headerMobile":"Lc32r8Hqkeediu5BdRP0","row":"jUF8jYTWYBNsoYnJekEN"};